import { CompanyRevenueType } from "interfaces/company";

export const getManagementInfo = (companyRevenueType?: CompanyRevenueType) => companyRevenueType === CompanyRevenueType.SUBSCRIPTIONS
  ? { name: 'Revenue Management', path: '/data-input/revenue-management' }
  : { name: 'Contract Management', path: '/data-input/contract-management' };
